import React, { useEffect, useState } from 'react'
import { Modal, Select, Tabs, Pagination } from '@mantine/core'
import List from '../common/List'
import MantineSelectBox from '../common/MantineSelectBox'
import SaveButton from '../common/SaveButton'
import styles from '../../styles/admin/Main.module.scss'
import { useAuthStore } from '../../store'
import { apiRequest } from '../../utils/api'
import { notifications } from '@mantine/notifications'

const OrdersBox = () => {
  const user = useAuthStore((state) => state.user)
  const [searchTitle, setSearchTitle] = useState('')
  const [searchPublisher, setSearchPublisher] = useState('')
  const [searchType, setSearchType] = useState('')
  const [stateType, setStateType] = useState('')
  const [activeTab, setActiveTab] = useState('manual')
  const [bookInfoData, setBookInfoData] = useState([])
  const [manualData, setManualData] = useState([])
  const [subscribeData, setSubscribeData] = useState([])
  const [subscribeType, setSubscribeType] = useState('')
  const [viewForm, setViewForm] = useState({})
  useEffect( () => {
    if (activeTab === 'manual') {
       fetchManualData()
    } else if (activeTab === 'bookInfo') {
       fetchBookInfoData()
    } else if (activeTab === 'subscribe') {
       fetchSubscribeData()
    }
  }, [activeTab])

  const fetchManualData = async () => {
    try {
      const res = await apiRequest('/getManualData', 'POST',{searchType,center : user.CENTER_ID,})
      if (res.data) {
        const filteredData = res.data.map((upload, index) => {
          const baseData = {
            NO: index + 1,
            ITEM_CD: upload.ITEM_NM,
            TITLE: (
              <div className="list-cell-content" style={{ display: 'flex', justifyContent: 'flex-start', width: '100%'}}>
                {upload.TITLE}
              </div>
            ),
            TOTAL_PRICE: upload.TOTAL_PRICE,
            BUYER_NAME: upload.BUYER_NAME,
            CENTER: upload.CENTER,
            REG_DTM: upload.REG_DTM
          }
          // 매니저인 경우 기본 데이터만 반환
          return baseData
        })
        setManualData(filteredData)
      }
    } catch (err) {
      console.error('Failed to fetch uploaded data:', err)
      notifications.show({
        title: 'Error',
        message: 'Failed to load uploaded data.',
        color: 'red',
      })
    }
  }

  const fetchBookInfoData = async () => {
    try {
      const res = await apiRequest('/getBookInfoData', 'POST', {
        center : user.CENTER_ID,
        title : searchTitle,
        publisher : searchPublisher,
        stateType : stateType
      })
      if (res.data) {
        const filteredData = res.data.map((upload, index) => {
          const baseData = {
            NO: index + 1,
            ITEM_CD: upload.ITEM_CD,
            TITLE: (
              <div className="list-cell-content" style={{ display: 'flex', justifyContent: 'flex-start', width: '100%'}}>
                {upload.TITLE}
              </div>
            ),
            COUNT: upload.COUNT,
            TOTAL_PRICE: upload.TOTAL_PRICE,
            BUYER_NAME: upload.BUYER_NAME,
            CENTER: upload.CENTER,
            REG_DTM: upload.REG_DTM,
            STATE: user.STATUS === 'A' ? (
              <Select
                data={[
                  { label: 'Delivered', value: 'Y' },
                  { label: 'Undelivered', value: 'N' },
                ]}
                value={upload.STATE}
                onChange={(value) => {
                  handleStateChange(upload.ID, value)
                }}
                placeholder="Choose State"
                size="xs"
              />
            ) : (
              <Select
                data={[
                  { label: 'Delivered', value: 'Y' },
                  { label: 'Undelivered', value: 'N' },
                ]}
                value={upload.STATE}
                onChange={(value) => {
                  handleStateChange(upload.ID, value)
                }}
                placeholder="Choose State"
                size="xs"
                readOnly
              />
            )}
          // 매니저인 경우 기본 데이터만 반환
          return baseData
        })
        setBookInfoData(filteredData)
      }
    } catch (err) {
      console.error('Failed to fetch uploaded data:', err)
      notifications.show({
        title: 'Error',
        message: 'Failed to load uploaded data.',
        color: 'red',
      })
    }
  }





  const handleStateChange = async (ID, STATE) => {
    try {
      const res = await apiRequest('/handleStateChange', 'POST',{ID, STATE})
      if (res.success) {
        fetchBookInfoData()
      }
    } catch (err) {
      console.error('Failed to fetch uploaded data:', err)
      notifications.show({
        title: 'Error',
        message: 'Failed to load uploaded data.',
        color: 'red',
      })
    }
  }

  const fetchSubscribeData = async () => {

    try {
      const res = await apiRequest('/getSubscribeData', 'POST',{subscribeType})
      if (res.data) {
        const filteredData = res.data.map((upload, index) => {
          const baseData = {
            NO: index + 1,
            ORDER_ID: upload.ORDER_ID ? upload.ORDER_ID : '-',
            ITEM_CD: upload.ITEM_NM,
            NAME: upload.NAME,
            TOTAL_PRICE: upload.TOTAL_PRICE,
            SUB_CAN_TYPE_NM: upload.SUB_CAN_TYPE_NM,
            START_DATE: upload.START_DATE,
            END_DATE: upload.END_DATE,
            checked: false,
            _id: upload.ID,
            _userId: upload.BUYER_NAME,
            _SUB_CAN_TYPE: upload.SUB_CAN_TYPE
            }
          // 매니저인 경우 기본 데이터만 반환
          return baseData
        })
        setSubscribeData(filteredData)
      }
    } catch (err) {
      console.error('Failed to fetch uploaded data:', err)
      notifications.show({
        title: 'Error',
        message: 'Failed to load uploaded data.',
        color: 'red',
      })
    }
  }

  const manualHeaders = ['No', 'Program Type', 'Title', 'total Price','Purchaser','Purchase Center','Purchase Date']
  const manualColumnWidths = ['5%','10%', '45%', '10%', '10%', '10%','10%']

  const manualHeaders2 = ['No', 'Serial Number','Title', 'Total Books', 'total Price', 'Purchaser', 'Center','Date','state']
  const manualColumnWidths2 = ['5%', '14%', '27%', '10%', '9%', '9%', '9%', '9%','9%']

  const manualHeaders3 = ['No', '결제번호', '구독형태', '이름', '금액', '구독상태','시작일','마감일']
  const manualColumnWidths3 = ['5%', '15%', '15%', '15%', '20%', '10%', '10%','10%']

  const dataType = [
    { value: '', label: 'All' },
    { value: 'A', label: 'PreSchool' },
    { value: 'B', label: 'AfterSchool' },
  ]

  const dataState = [
    { value: 'Y', label: 'Active' },
    { value: 'N', label: 'Inactive' },
  ]

  const dataStep = [
    { value: '', label: 'All' },
    { value: 'Y', label: 'Delivered' },
    { value: 'N', label: 'Undelivered' },
  ]

  const dataSub = [
    {value:'',label:'All'},
    {value:'monthly',label:'월간구독'},
    {value:'Yearly',label:'연간구독'},
  ]

  const handleReset = () => {
    setSearchTitle('')
    setSearchPublisher('')
    setSearchType('')
    setSubscribeType('')
  }
//구독취소 승인(a), 거절(r)
const handleSubUpdate = async(val) => {
    const selectedItems = subscribeData.filter(item => item.checked);

      if (selectedItems.length === 0 ) {
        return notifications.show({
          title: 'Warning',
          message: 'No subscription data selected',
          color: 'yellow',
        });
      }

    // 🔍 하나라도 I가 아닌게 있는지 체크
    const hasInvalid = selectedItems.some(item => item._SUB_CAN_TYPE !== 'I');

    if (hasInvalid) {
      return notifications.show({
        title: 'Warning',
        message: 'Only cancellation request items can be selected.',
        color: 'yellow',
      });
    }


      try {
        const res = await apiRequest('/updateSubscribe', 'POST', {
          type : val, // 승인/거절 상태
          items: selectedItems,
        });

        if (res.success) {
          notifications.show({
            title: 'Success',
            message: 'Success',
            color: 'green',
          });
          fetchSubscribeData(); // 최신화
        }

      } catch (err) {
        console.error(err);
      }
}
const handleCheck = (index) => { //구독에서 체크된
  setSubscribeData(prev =>
    prev.map((item, i) =>
      i === index ? { ...item, checked: !item.checked } : item
    )
  );
};

  return (
    <div>
      <Tabs color="blue" defaultValue="manual" value={activeTab} onChange={setActiveTab}>
        <Tabs.List style={{ width: '100%' }}>
          <Tabs.Tab style={{ flex: 1 }} value="manual">
            Manual
          </Tabs.Tab>
          <Tabs.Tab style={{ flex: 1 }} value="bookInfo">
            Book Info
          </Tabs.Tab>
          {user?.STATUS === 'A' && (
            <Tabs.Tab style={{ flex: 1 }} value="subscribe">
              Subscribe
            </Tabs.Tab>
          )}
        </Tabs.List>

        <Tabs.Panel value="manual" pt="lg">
          <div className="uploads-search-section">
            <div className="search-section">
              <MantineSelectBox
                width="200px"
                value={searchType}
                onChange={setSearchType}
                data={dataType}
              />
            </div>
            <div className="search-buttons">
              <SaveButton className="update-button" onClick={handleReset}>
                Reset
              </SaveButton>
              <SaveButton onClick={fetchManualData}>Search</SaveButton>
            </div>
          </div>

          <List
            showCheckbox={false}
            headers={manualHeaders}
            data={manualData}
            columnWidths={manualColumnWidths}
          />

          <div className={styles.paginationWrapper}>
            <Pagination
              value={1}
              onChange={() => {}}
              total={1}
              size="sm"
              withEdges={false}
              color="gray"
              classNames={{
                control: styles.paginationControl,
              }}
            />
          </div>

          <div className="users-select-wrapper">
            <Select
              styles={{ input: { width: '150px', height: '30px' } }}
              data={['10entries', '20entries', '50entries']}
              value="10entries"
              onChange={() => {}}
            />
          </div>
        </Tabs.Panel>

        <Tabs.Panel value="bookInfo" pt="lg">
          <div className="uploads-search-section">
            <div className="search-section">
              <input
                className="search-input"
                placeholder="Title"
                value={searchTitle}
                onChange={(e) => setSearchTitle(e.target.value)}
              />
              <input
                className="search-input"
                placeholder="Teaching Tool Serial Number"
                value={searchPublisher}
                onChange={(e) => setSearchPublisher(e.target.value)}
              />
              <MantineSelectBox
                width="200px"
                value={stateType}
                onChange={setStateType}
                data={dataStep}
              />
            </div>
            <div className="search-buttons">
              <SaveButton className="update-button" onClick={handleReset}>
                Reset
              </SaveButton>
              <SaveButton onClick={fetchBookInfoData}>Search</SaveButton>
            </div>
          </div>

          <List
            showCheckbox={false}
            headers={manualHeaders2}
            data={bookInfoData}
            columnWidths={manualColumnWidths2}
          />

          <div className={styles.paginationWrapper}>
            <Pagination
              value={1}
              onChange={() => {}}
              total={1}
              size="sm"
              withEdges={false}
              color="gray"
              classNames={{
                control: styles.paginationControl,
              }}
            />
          </div>

          <div className="users-select-wrapper">
            <Select
              styles={{ input: { width: '150px', height: '30px' } }}
              data={['10entries', '20entries', '50entries']}
              value="10entries"
              onChange={() => {}}
            />
          </div>
        </Tabs.Panel>

        <Tabs.Panel value="subscribe" pt="lg">
          <div className="uploads-search-section">
            <div className="search-section">
              <MantineSelectBox
                width="200px"
                value={subscribeType}
                onChange={setSubscribeType}
                data={dataSub}
              />
            </div>
            <div className="search-buttons">
               <SaveButton className="update-button" onClick={() => handleSubUpdate('a')}>
                 승인
              </SaveButton>
              {/*
              <SaveButton className="update-button" onClick={() => handleSubUpdate('r')}>
                 거절
              </SaveButton>
              */}
              <SaveButton className="update-button" onClick={handleReset}>
                Reset
              </SaveButton>
              <SaveButton onClick={fetchSubscribeData}>Search</SaveButton>
            </div>
          </div>

          <List
            showCheckbox={true}
            headers={manualHeaders3}
            data={subscribeData}
            columnWidths={manualColumnWidths3}
            isChecked={false}
            onCheck={handleCheck}
          />

          <div className={styles.paginationWrapper}>
            <Pagination
              value={1}
              onChange={() => {}}
              total={1}
              size="sm"
              withEdges={false}
              color="gray"
              classNames={{
                control: styles.paginationControl,
              }}
            />
          </div>

          <div className="users-select-wrapper">
            <Select
              styles={{ input: { width: '150px', height: '30px' } }}
              data={['10entries', '20entries', '50entries']}
              value="10entries"
              onChange={() => {}}
            />
          </div>
        </Tabs.Panel>
      </Tabs>
    </div>
  )
}

export default OrdersBox
